import {
  fontSize,
  primaryRegularFont,
  primarySemiBoldFont,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { applyKeyframe, pxToRem } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const { spacing, text } = theme;

export const deliveryBlock = css`
  background: var(--brand-purple-30);
  border-radius: ${pxToRem(10)};
  padding: ${pxToRem(spacing.xl)};
`;

export const countrySelect = css`
  margin-bottom: ${pxToRem(spacing.xs)};
`;

export const countryInfoWrapper = css`
  display: grid;
  grid-template-columns: auto 1fr;
`;

export const countryInfoMessage = css`
  ${primaryRegularFont}
  ${fontSize(text.BODY.XS)}

  margin: 0 0 0 ${pxToRem(spacing.base)};
`;

export const deliveryOptionsList = css`
  border-top: ${pxToRem(1)} solid var(--neutral-black-70);
  padding: ${pxToRem(spacing.xl)} 0 0;
  margin: ${pxToRem(28)} 0 0;
  list-style: none;
`;

export const deliveryOption = css`
  margin: 0 0 ${pxToRem(spacing.sm)};

  &:last-child {
    margin: 0;
  }
`;

export const deliveryType = css`
  ${primaryRegularFont}
  ${fontSize(text.BODY.XS)}
  margin: 0;
`;

export const dateAndPriceWrapper = css`
  ${primarySemiBoldFont}

  display: flex;
  column-gap: ${pxToRem(spacing.sm)};
  justify-content: space-between;
`;

export const dateAndPrice = css`
  ${fontSize(text.BODY.XS)}

  margin: 0;
`;

export const firstDateAndPrice = css`
  ${fontSize(text.BODY.MD)}
`;

export const deliveryNotAvailableMessage = css`
  ${primarySemiBoldFont}

  border-top: ${pxToRem(1)} solid var(--neutral-black-70);
  padding: ${pxToRem(spacing.xl)} 0 0;
  margin: ${pxToRem(28)} 0 0;
`;

export const deliveryOptionSkeletonWrapper = css`
  display: grid;
  column-gap: ${pxToRem(spacing.sm)};
  grid-template-columns: auto ${pxToRem(50)};
`;

export const optionTypeSkeleton = css`
  grid-column: 1 / -1;
  margin: ${pxToRem(1)} 0;
`;

export const dateAndPriceSkeleton = css`
  margin: ${pxToRem(1)} 0;
`;

export const firstDateAndPriceSkeleton = css`
  margin: ${pxToRem(2)} 0;
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeIn = css`
  animation: ${applyKeyframe(fadeInAnimation)} 400ms linear;
`;
